import React, { Component } from 'react';
import { Button, CustomInput, Table } from 'reactstrap';
import PropTypes from 'prop-types';

const TableItem = ({ todo, toggleSelect, toggleComplete }) => (
    <tr className='my-2' >
        <th scope="row">
            <CustomInput
                type="checkbox"
                id={todo.id}
                checked={todo.isSelect}
                onChange={() => toggleSelect(todo.id)}
            />
        </th>
        <td>
            {todo.time.toDateString()}
        </td>
        <td>{todo.text}</td>
        <td>
            <Button type="button" color={todo.isComplete ? 'danger' : 'success'} onClick={() => toggleComplete(todo.id)} >
                {todo.isComplete ? 'Completed' : 'Running'}
            </Button>
        </td>
    </tr>
);

TableItem.propTypes = {
    todo: PropTypes.object.isRequired,
    toggleSelect: PropTypes.func.isRequired,
    toggleComplete: PropTypes.func.isRequired
};

export default class TableView extends Component {
    render() {
        const { todos, toggleComplete, toggleSelect } = this.props;
        return (
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Date</th>
                        <th>Note</th>
                        <th>Action</th>
                    </tr>
                </thead>
                {todos.map(todo => (
                    <TableItem key={todo.id} id={todo.id} todo={todo} toggleComplete={toggleComplete} toggleSelect={toggleSelect} />
                ))}
            </Table>
        );
    }
}

TableView.propTypes = {
    todos: PropTypes.object.isRequired,
    toggleSelect: PropTypes.func.isRequired,
    toggleComplete: PropTypes.func.isRequired
};